import React from 'react';
import classnames from 'classnames';

import { ContentBlock } from '../../ContentBlock/ContentBlock';
import { VideoPlayer } from '../../VideoPlayer/VideoPlayer';
import { VideoAndTextComponentFragment } from '../../../../graphql.schema';

// import * as styles from './video-and-text.module.scss';

export const StrapiVideoAndTextComponent: React.FC<VideoAndTextComponentFragment> = (props) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./video-and-text.module.scss');
  if (isV2) {
    styles = require('./video-and-text-v2.module.scss');
  }

  return (
    <div className={classnames(styles.root, { [styles.alternate]: props.shadedBackground })}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.contentBlock}>
            <ContentBlock
              title={props.title}
              titleClass={classnames('is-3', styles.title)}
              contentClass={styles.content}
              content={props.intro ?? undefined}
              links={props.links ?? undefined}
              button={props.button ?? undefined}
            />
          </div>
          <div className={styles.video}>
            {props.video?.url ? (
              <VideoPlayer video={props.video} poster={props.videoThumbnail?.formats?.small?.url} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
